var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"ReChannelEdit"},[(_vm.bIsNew)?_c('h3',{staticClass:"mb-1"},[_vm._v("Новый канал")]):_c('h3',[_vm._v("Редактирование канала")]),_c('hr'),_c('ReFormPrinter',{attrs:{"masFormConfig":_vm.masAllFormParams,"objSaveApiMethod":_vm.currentApiSaveMethod,"SuccessGo":_vm.SuccessGo,"CancelGo":_vm.CancelGo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }